/**
 * Frontend twin of `backend/src/utils/pendingNotification.ts` — the ONE
 * definition of a "pending notification": an assignment the crew member has
 * never been emailed about and is still waiting to respond to.
 *
 *   notificationSentAt is null  AND  status === 'ASSIGNED'  AND  event not CANCELLED
 *
 * CONFIRMED is deliberately not pending (whoever confirmed it, the person
 * already knows); DECLINED / CANCELLED are moot. Used by the event page's
 * banner / header tag / row chip and the Message Crew modal's notice. Lists
 * that come from `GET /api/assignments/pending-notifications` are already
 * filtered server-side with the same rule.
 */

export interface PendingNotificationCandidate {
  status: string;
  notificationSentAt?: string | null;
}

export function isPendingNotification(
  assignment: PendingNotificationCandidate,
  event?: { status: string } | null
): boolean {
  if (event?.status === 'CANCELLED') return false;
  return assignment.status === 'ASSIGNED' && !assignment.notificationSentAt;
}
